import { Directive, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';

/**
 * Directive to update the native element's aria attributes
 * for Ionic Elements. Please check if bug has been fixed in Ionic 7
 * https://github.com/ionic-team/ionic-framework/issues/23213
 */
@Directive({
    selector: '[ridangoUpdateIonAria]'
})
export class UpdateNativeAriaDirective implements AfterViewInit, OnDestroy {
    private observer?: MutationObserver;
    private readonly ariaAttributes = ['aria-label', 'aria-checked'];
    private readonly shadowTargets: string[] = ['.button-native'];

    constructor(private el: ElementRef) {}

    ngAfterViewInit() {
        const ionButton = this.el.nativeElement as HTMLElement;

        const applyAttributes = () => {
            const shadowRoot = ionButton.shadowRoot || (ionButton as any).shadowRoot;
            if (!shadowRoot) return;

            for (const selector of this.shadowTargets) {
                const target = shadowRoot.querySelector(selector);
                if (target) {
                    this.ariaAttributes.forEach((attr) => {
                        const value = ionButton.getAttribute(attr);
                        if (value !== null) {
                            target.setAttribute(attr, value);
                        }
                    });
                    break;
                }
            }
        };

        applyAttributes();

        this.observer = new MutationObserver(() => applyAttributes());
        this.observer.observe(ionButton, { attributes: true, attributeFilter: this.ariaAttributes });
    }

    ngOnDestroy(): void {
        this.observer?.disconnect();
    }
}
